import React, {forwardRef} from 'react';
import styled from 'styled-components';

import {IconButton, IconButtonProps} from './iconButton';

/*
 * Props.
 */

export interface ToolbarButtonProps extends IconButtonProps {
  noMargin?: boolean;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div<{$noMargin: boolean}>`
  ${(p) => (p.$noMargin ? 'margin: 0' : 'margin: 0 3px;')}
`;

/*
 * Component.
 */

export const ToolbarButton = forwardRef<HTMLDivElement, ToolbarButtonProps>((props, ref) => (
  <StyledWrapperDiv ref={ref} $noMargin={Boolean(props.noMargin)}>
    <IconButton {...props} />
  </StyledWrapperDiv>
));
